import React, { Component } from 'react';
import gql from 'graphql-tag';
import cloneDeep from 'lodash/cloneDeep';
import PropTypes from 'prop-types';
import { compose, graphql, withApollo } from 'react-apollo';
import { Modal } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { SUBSCRIPTION_PREFERRED_LOCATION_CHANGED } from 'containers/DesktopNotificationTray';
import ADialog from 'components/ADialog';
import CurrencyIcon from 'components/CurrencyIcon';
import GameChat from 'components/GameChat';
import LoadingIndicator from 'components/LoadingIndicator';
import RoundTicker from 'components/RoundTicker';
import SafeMarkdown from 'components/SafeMarkdown';
import SixtySeconds from 'components/SixtySeconds';
import StepperInput from 'components/StepperInput';
import TextButton from 'components/TextButton';
import UserAvatar from 'components/UserAvatar';
import { LG_BREAKPOINT_AND_UP } from 'utils/constants';
import { augmentDrawing } from 'utils/drawings';
import { getUserData } from 'utils/graphQLFunctions';
import { truncateText } from 'utils/strings';
import withMediaQuery from 'utils/withMediaQuery';
import ChatIcon from 'resources/Footer-Icon-Chat.png';
import CloseIcon from 'resources/Icon-Close-Btn.svg';
import LeaderboardIcon from 'resources/Footer-Icon-Leaderboard.png';
import TicketIcon from 'resources/ui-icon-ticket-currency.png';
import Drum from '../Drum';
import Scrollable from '../Scrollable';
import { fetchDrawing, fetchMyEnteredTickets } from '../utils/cacheHandling';
import { updateDrawings } from '../utils/cacheHandling';
import { getDrawingsQuery } from '../utils/common';
import {
  DRAWING_BOARD_EVENTS,
  SUBSCRIPTION_BOARD_UPDATES_EVENTS
} from '../utils/drawingConstants';
import {
  addDrawingEvent,
  addDrawingEvents,
  updateLastDrawingEvent
} from '../utils/eventReducer';
import DrawingDetails from './DrawingDetails';
import DrawingLeaderboard from './DrawingLeaderboard';
import { DrawingEntryStatsRow } from './components/drawingElements';
import './ViewDrawing.css';

//  ----------------------------------------------------------------------------------------------//
const errorMsg = (
  <React.Fragment>
    <h4>Something Went Wrong!</h4>
    <span>Please try refreshing your page and try again.</span>
  </React.Fragment>
);

//  ----------------------------------------------------------------------------------------------//
class ViewDrawing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      myTickets: 0,
      ticketsToAdd: 1,
      show: false,
      message: null,
      claimTimeout: false,
      drawing: false,
      drumClosed: false,
      drawingStatus: '',
      hasEnteredFreeTicket: false,
      currentRound: false,
      totalPlaces: false,
      title: false,
      showLeaderboardModal: false,
      showChatModal: false
    };
  }

  componentDidMount() {
    this.unSubscribeToScrollUpdates = this.props.subscribeToScrollUpdates(
      this.props,
      this.updateByEvents
    );
    this.unsubscribeToLocationData = this.props.subscribeToLocationData();

    const { match, client } = this.props;
    const { id } = match.params;

    let tickets = fetchMyEnteredTickets(client, id);
    Promise.resolve(tickets).then(result => {
      this.setState({ myTickets: result });
    });

    let fetchedDrawing = fetchDrawing(client, id);
    Promise.resolve(fetchedDrawing).then(result => {
      this.setState({ drawing: result });

      this.setState({
        drumClosed:
          result.timeLeft() < 60000 || result.drawingState !== 'Upcoming',
        drawingStatus: result.drawingState,
        hasEnteredFreeTicket: result.hasEnteredFreeTicket,
        currentRound: result.currentRound,
        totalPlaces: result.totalPlaces,
        title: result.title
      });
    });
  }

  componentWillUnmount() {
    this.unsubscribeFromBoardUpdates && this.unsubscribeFromBoardUpdates();
    this.unSubscribeToScrollUpdates && this.unSubscribeToScrollUpdates();
    this.unsubscribeToLocationData && this.unsubscribeToLocationData();
  }

  componentDidUpdate(prevProps, prevState) {
    const { userData } = this.props;
    const { userData: prevUserData } = prevProps;

    const prevPreferred = prevUserData?.user?.preferredLocation;
    const currentPreferred = userData?.user?.preferredLocation;

    if (prevPreferred !== undefined && currentPreferred !== undefined) {
      if (prevPreferred !== currentPreferred) {
        this.handleUserPreferredLocationUpdate();
      }
    }

    const myTicketsNum = this.props.myTicketsNum || 0;
    let ticketsToAdd = prevState.ticketsToAdd;

    if (ticketsToAdd > myTicketsNum) {
      this.setState({ ticketsToAdd: myTicketsNum });
    } else if (ticketsToAdd === 0 && myTicketsNum > 0) {
      this.setState({ ticketsToAdd: 1 });
    }
  }

  subscribe = () => {
    const { userId } = this.props.userData.user.userId;
    this.unsubscribetoBoardUpdates = this.props.subscribeToBoardUpdates(
      userId,
      this.onSubscribeToEventsUpdate,
      this.updateMyTickets
    );
    this.hasSubscribed = true;
  };

  handleUserPreferredLocationUpdate = () => {
    this.props.history.push('/drawings');
  };

  onSubscribeToEventsUpdate = myUpdatedTickets => {
    if (myUpdatedTickets || myUpdatedTickets === 0) {
      this.updateMyTickets(myUpdatedTickets);
    }
  };

  updateMyTickets = myUpdatedTickets =>
    this.setState({ myTickets: myUpdatedTickets });

  updateByEvents = drawing => {
    let claimTimeout = this.state.claimTimeout;
    if (
      claimTimeout &&
      (!drawing ||
        drawing.lastEvent === DRAWING_BOARD_EVENTS.ROUND ||
        drawing.lastEvent === DRAWING_BOARD_EVENTS.CLAIMED ||
        drawing.lastEvent === DRAWING_BOARD_EVENTS.END)
    ) {
      this.setState({ claimTimeout: false });
    }
    this.setState({
      drawing: drawing,
      ...(drawing.lastEvent === DRAWING_BOARD_EVENTS.END && {
        myTickets: null // NOTE: make null to remove number from UI that looks the all rounds has been end, instead of zero that looks like run out of tickets
      })
    });
  };

  //  ---------------------------------
  checkErrors() {
    return (
      this.props.drawingData.error ||
      this.props.userData.error ||
      this.props.ticketsNumData.error ||
      this.props.boardData.error
    );
  }

  checkLoading() {
    return (
      !this.props.commonDrawingsData ||
      this.props.commonDrawingsData.loading ||
      this.props.drawingData.loading ||
      this.props.userData.loading ||
      this.props.ticketsNumData.loading ||
      this.props.boardData.loading
    );
  }

  //  ---------------------------------
  handleClose() {
    this.setState({
      show: false,
      title: false,
      message: null
    });
  }

  handleTicketsAdd(inc) {
    if (
      (inc === 1 && this.state.ticketsToAdd < this.props.myTicketsNum) ||
      (inc === -1 && this.state.ticketsToAdd > 1)
    ) {
      this.setState({
        ticketsToAdd: this.state.ticketsToAdd + inc
      });
    }
  }

  handleTicketsToAddChange(e) {
    let t = parseFloat(e.target.value);
    if (isNaN(t)) {
      t = '';
    } else if (t < 1) {
      t = 1;
    } else if (t > this.props.myTicketsNum) {
      t = this.props.myTicketsNum;
    }
    this.setState({
      ticketsToAdd: t
    });
  }

  handleAddFreeTicketToUser() {
    if (this.state.hasEnteredFreeTicket) {
      return;
    }

    this.setState({ show: false, title: false });
    this.props
      .addFreeTicketToDrawing()
      .then(resp => {
        // resp:
        //   data:
        //     addFreeTicket:
        //       success: true
        if (resp && resp.data) {
          if (resp.data.addFreeTicket.success) {
            this.setState({ hasEnteredFreeTicket: true });
          } else {
            console.error(
              'addMyTicketsToDrawing error',
              resp.data.addFreeTicket.message
            );
            this.setState({ show: 'confirmation', message: errorMsg });
          }
        }
      })
      .catch(e => {
        console.error('handleAddTicketsToUser exception', e);
        this.setState({ show: 'confirmation', message: errorMsg });
      });
  }

  handleTerms() {
    this.setState({ show: 'eligibility' });
  }

  handleDrumClose() {
    this.setState({ drumClosed: true });
  }

  confirmAddTicketsToUser() {
    let tnum = parseFloat(this.state.ticketsToAdd);
    if (tnum <= 0 || !this.props.myTicketsNum) {
      return;
    }
    this.setState({
      title: 'Confirm Entry',
      show: 'confirmation',
      message: (
        <React.Fragment>
          You are about to enter{' '}
          <span className="highlighted">
            {tnum} {tnum > 1 ? 'Entries' : 'Entry'}{' '}
          </span>
          in the Drawing.
          <br />
          <br />
          Are you sure?
        </React.Fragment>
      )
    });
  }

  handleAddTicketsToUser() {
    let tnum = parseFloat(this.state.ticketsToAdd);
    this.setState({ show: false, title: false });
    this.props
      .addMyTicketsToDrawing(tnum)
      .then(resp => {
        // resp:
        //   data:
        //     addMyTicketsToDrawing:
        //       affectedCount: 1
        //       message: "Tickets were added to drawing!"
        //       success: true
        //       userId: 10524
        if (resp && resp.data) {
          if (!resp.data.addMyTicketsToDrawing.success) {
            console.error(
              'addMyTicketsToDrawing error',
              resp.data.addMyTicketsToDrawing.message
            );
            this.setState({ show: 'confirmation', message: errorMsg });
          }
        }
      })
      .catch(e => {
        console.error('handleAddTicketsToUser exception', e);
        this.setState({ show: 'confirmation', message: errorMsg });
      })
      .finally(e => {
        this.setState({ ticketsToAdd: 1 });
      });
  }

  renderLeaderboard() {
    const { board, userData, ticketsData } = this.props;
    const { drawing, drumClosed, myTickets } = this.state;
    return (
      <DrawingLeaderboard
        board={board}
        userData={userData}
        ticketsData={ticketsData}
        myTickets={myTickets}
        drawing={drawing}
        drumClosed={drumClosed}
      />
    );
  }

  renderLeaderboardModalButton() {
    return (
      <>
        <button
          className="show-leaderboard-button"
          aria-label="Show leaderboard button"
          onClick={() => this.setState({ showLeaderboardModal: true })}
          type="button"
        >
          <img src={LeaderboardIcon} alt="Show leaderboard" />
        </button>
        <Modal
          className="leaderboard-modal"
          show={this.state.showLeaderboardModal}
          onHide={() => this.setState({ showLeaderboardModal: false })}
        >
          <Modal.Body>{this.renderLeaderboard()}</Modal.Body>
        </Modal>
      </>
    );
  }

  renderChatModalButton() {
    const { drawing } = this.state;
    const { board } = this.props;
    return (
      <>
        <button
          className="show-chat-button"
          aria-label="Show chat button"
          onClick={() => this.setState({ showChatModal: true })}
          type="button"
        >
          <img src={ChatIcon} alt="Show chat" />
        </button>
        <Modal
          className="chat-modal"
          show={this.state.showChatModal}
          onHide={() => this.setState({ showChatModal: false })}
        >
          <Modal.Body>
            <GameChat
              room={`drw_${drawing.id}`}
              title="Drawing Chat"
              participantData={board}
            />
          </Modal.Body>
        </Modal>
      </>
    );
  }

  renderSubmitEntryControls() {
    const { myTicketsNum, matchesBreakpoint: isDesktopOrLarger } = this.props;
    const { hasEnteredFreeTicket, drumClosed } = this.state;
    const moreThan24hrs = this.props.drawing.timeLeft() > 86400000;
    const claimAllowed = !drumClosed && !hasEnteredFreeTicket && !moreThan24hrs;
    const submitAllowed = !drumClosed && myTicketsNum > 0;

    return (
      <div className="footer-entry-amount-controls-container">
        <div className="stepper-container">
          {!isDesktopOrLarger && this.renderChatModalButton()}
          <StepperInput
            disabled={!submitAllowed}
            value={this.state.ticketsToAdd}
            onEdit={e => this.handleTicketsToAddChange(e)}
            onIncrease={e => this.handleTicketsAdd(1)}
            onDecrease={e => this.handleTicketsAdd(-1)}
            icon={TicketIcon}
          />
          {!isDesktopOrLarger && this.renderLeaderboardModalButton()}
        </div>
        <div className="submit-controls">
          <button
            className={`btn ${
              claimAllowed ? 'button-color-blue' : 'disabled-btn'
            }`}
            onClick={() => this.handleAddFreeTicketToUser()}
            type="button"
            disabled={!claimAllowed}
          >
            Claim Free Entry
          </button>
          <button
            className={`btn ${
              submitAllowed ? 'button-color-green' : 'disabled-btn'
            }`}
            onClick={() => this.confirmAddTicketsToUser()}
            type="button"
            disabled={!submitAllowed}
          >
            Submit
          </button>
        </div>
      </div>
    );
  }

  renderRoundTicker() {
    const { drawing } = this.state;
    const round = drawing.currentRound || 0;
    const prizes = drawing?.prizesForRound(round);

    if (round === 0) {
      return (
        <div className="tickets-info in-progress">
          <div className="prize-desc">
            Please wait, the next round will start soon.
          </div>
        </div>
      );
    }

    return (
      <RoundTicker
        step={2000}
        rounds={prizes.length}
        className="tickets-info in-progress"
      >
        {prizes.map((p, idx) => (
          <div className={'round-ticker-inner-' + idx} key={'prize-' + idx}>
            <div className="prize">
              {p.url && <img src={p.url} alt={p.name} />}
            </div>
            <div className="prize-desc">
              <p>
                Selecting prize winner {round} of {drawing.totalPlaces}
                &nbsp;({prizes.length}&nbsp;
                {prizes.length === 1 ? 'PRIZE' : 'PRIZES'})
              </p>
              <h4>{p.name}</h4>
            </div>
          </div>
        ))}
      </RoundTicker>
    );
  }

  //TODO: Update function name
  renderSubmits() {
    const { drawing } = this.state;
    const { matchesBreakpoint: isDesktopOrLarger } = this.props;

    if (drawing.drawingState === 'InProgress') {
      return isDesktopOrLarger ? (
        this.renderRoundTicker()
      ) : (
        <div className="player-detail-footer-container">
          <div className="buttons-container">
            {this.renderChatModalButton()}
            {this.renderLeaderboardModalButton()}
          </div>
          {this.renderPlayerDetailsFooter()}
        </div>
      );
    }

    if (drawing.drawingState === 'Completed') {
      return (
        <div className="tickets-info completed">
          <h4>Thank you for playing!</h4>
        </div>
      );
    }

    if (!drawing.userInGroup) {
      return (
        <div className="tickets-info not-eligible">
          <span>You are not eligible to add entries to this drawing.</span>
          <br />
          <span>Feel free to watch the drawing to see who wins!</span>
        </div>
      );
    }

    if (!drawing.allTicketsAllowed) {
      return (
        <div className="tickets-info not-eligible">
          Special entries are needed for entering into this drawing. Please see
          the drawing description on how to obtain entries for this drawing.
        </div>
      );
    }

    return (
      <div className="drawing-right-panel-active-footer">
        <div className="footer-title-container">Add Entries</div>
        {this.renderSubmitEntryControls()}
        {!isDesktopOrLarger && this.renderPlayerDetailsFooter()}
      </div>
    );
  }

  renderPlayerDetailsFooter() {
    const getMyLeaderboardRank = () => {
      if (!this.props.boardData.drawingBoard.myEnteredTickets) {
        return '-';
      }

      const myId = this.props.userData.user.userId;
      const board = [...this.props.boardData.drawingBoard.drawingBoard];
      const boardLength = board.length;
      let pos = 0;

      const sortedBoard = board.map(item => ({
        ...item,
        sortingValue: item.ticketsCount + (item.user.userId === myId ? 0.1 : 0)
      }));
      sortedBoard.sort((lhs, rhs) => rhs.sortingValue - lhs.sortingValue);

      for (let i = 0; i < boardLength; ++i) {
        if (i && board[i].ticketsCount !== board[i - 1].ticketsCount) {
          ++pos;
        }

        if (board[i].user.userId === myId) {
          return pos + 1;
        }
      }

      return '-';
    };

    return (
      <div className="user-info-footer">
        <div className="leaderboard-rank">{getMyLeaderboardRank()}</div>
        <div className="user-details">
          <UserAvatar
            avatarData={this.props.userData.user.avatarData}
            withBackground={true}
            className="user-avatar"
          />
          <span className="user-name">
            {this.props.userData.user.displayName}
          </span>
        </div>
        <div className="user-entries">
          <CurrencyIcon type="tickets" />
          <span>{this.state.myTickets}</span>
        </div>
      </div>
    );
  }

  renderInProgress() {
    const { drawing, claimTimeout } = this.state;
    if (!drawing.lastEvent) {
      return (
        <div className="left-col ">
          <div className="in-progress-indicator-title">Drawing In Progress</div>
          <br />
          <span className="in-progress-indicator-subtext">
            Please wait, updates will appear shortly.
          </span>
          <div className="ray-burst in-progress" />
        </div>
      );
    }
    if (
      drawing.lastEvent === DRAWING_BOARD_EVENTS.WINNER ||
      drawing.lastEvent === DRAWING_BOARD_EVENTS.CLAIMED
    ) {
      const err = Math.floor(
        (Date.now() - (drawing.lastEventTimeMs || Date.now())) / 1000
      );
      let willBe;
      if (drawing.lastEvent === DRAWING_BOARD_EVENTS.CLAIMED) {
        if (drawing.currentRound !== drawing.totalPlaces) {
          willBe = (
            <div className="ticker">
              <span className="highlight">Prize claimed!</span>
              <br />
              <span>The next prize will be</span>
              <br />
              <span>drawn in </span>
              <SixtySeconds className="highlight" ticks={15 - err} />
            </div>
          );
        } else {
          willBe = (
            <div className="ticker">
              <span className="highlight">Prize claimed!</span>
              <br />
              <span>See the list of winners</span>
              <br />
              <span>in </span>
              <SixtySeconds className="highlight" ticks={7 - err} />
            </div>
          );
        }
      } else {
        if (claimTimeout) {
          willBe = (
            <div className="ticker">
              <span>Prize not claimed.</span>
              <br />
              <span className="highlight">Redrawing...</span>
              <br />
              <span>&nbsp;</span>
            </div>
          );
        } else {
          willBe = (
            <div className="ticker">
              <span>If the prize is not claimed, another entry will be </span>
              <br />
              <span>drawn in </span>
              <SixtySeconds
                className="highlight"
                ticks={60 - err}
                onFinish={() =>
                  this.setState({
                    claimTimeout: true
                  })
                }
              />
            </div>
          );
        }
      }
      return (
        <div className="left-col running selected">
          <div className="announce">The selected entry is:</div>
          <div className="winner-name">
            <div
              className="winner-name-inner notranslate"
              title={drawing.lastWinnerName}
            >
              {truncateText(drawing.lastWinnerName, 28)}
            </div>
          </div>
          {willBe}
          <div className="ray-burst" />
        </div>
      );
    } else {
      //  if not - log the error in console mostly for debugging
      //  and anyway return Drum
      if (drawing.lastEvent !== DRAWING_BOARD_EVENTS.ROUND) {
        console.error(
          'ViewDrawing.renderDrum, inconsistent state/event:',
          drawing.drawingState,
          '/',
          drawing.lastEvent
        );
      }
      return (
        <div className="left-col running">
          <Drum />
          <div className="ray-burst" />
        </div>
      );
    }
  }

  renderCompleted() {
    const { drawing } = this.props;
    const place = drawing.placesWithPrizes();

    return (
      <Scrollable className="left-col completed">
        <div className="announce">Drawing complete!</div>
        <div className="winner-list">
          {place.map(p => (
            <div className="winner" key={p.place}>
              <div className="prize-num">
                Winner {p.place} of {drawing.totalPlaces}
              </div>
              {p.prizes.map(pr => (
                <div className="prize" key={pr.id}>
                  {pr.name}
                </div>
              ))}
              <div className="name">
                <div>Winner:</div>
                <div
                  className={
                    'highlight ' +
                    p.awarded.toLowerCase() +
                    (p.winner ? ' notranslate' : '')
                  }
                >
                  {p.winner
                    ? p.winner.displayName
                    : p.awarded?.toLowerCase() === 'unclaimed'
                    ? 'No Winner'
                    : p.awarded}
                </div>
              </div>
            </div>
          ))}
        </div>
      </Scrollable>
    );
  }

  renderDrawingDetails(showDrumState) {
    const { matchesBreakpoint: isDesktopOrLarger } = this.props;

    return (
      <div className="left-col">
        <DrawingDetails
          drawing={this.props.drawing}
          showDrumState={showDrumState}
          onDrumClose={() => this.handleDrumClose()}
          isDesktopOrLarger={isDesktopOrLarger}
          handleTerms={() => this.handleTerms()}
          renderRoundTicker={() => this.renderRoundTicker()}
        />
      </div>
    );
  }

  renderDrum() {
    const { matchesBreakpoint: isDesktopOrLarger } = this.props;
    const { drawing } = this.state;

    if (drawing.drawingState === 'InProgress') {
      return isDesktopOrLarger ? (
        this.renderInProgress()
      ) : (
        <>
          {this.renderDrawingDetails(false)}
          {this.renderInProgress()}
        </>
      );
    }

    if (drawing.drawingState === 'Completed') {
      return isDesktopOrLarger ? (
        this.renderCompleted()
      ) : (
        <>
          {this.renderDrawingDetails(false)}
          {this.renderCompleted()}
        </>
      );
    }

    return this.renderDrawingDetails(true);
  }

  renderTickets() {
    const {
      drawing,
      ticketsData,
      matchesBreakpoint: isDesktopOrLarger
    } = this.props;
    let prob = '0.00';

    if (this.state.myTickets && ticketsData.total) {
      prob = (this.state.myTickets / ticketsData.total) * 100;
      prob = prob < 0.01 ? '< 0.01' : prob.toFixed(2);
    }

    const drawingInfo = [
      { label: 'Total entries', value: ticketsData.total },
      { label: 'My entries', value: this.state.myTickets },
      { label: 'Win probability', value: `${prob}%` }
    ];

    return (
      <div className="right-col">
        {isDesktopOrLarger && (
          <div className="header">
            <div className="name">{drawing.name}</div>
            <div className="description">{drawing.description}</div>
            <div className="eligibility">
              <TextButton onClick={() => this.handleTerms()}>
                View Eligibility
              </TextButton>
            </div>
          </div>
        )}

        {drawingInfo.map((info, index) => (
          <DrawingEntryStatsRow
            key={index}
            label={info.label}
            value={info.value}
          />
        ))}

        {this.renderSubmits()}
      </div>
    );
  }

  render() {
    const { drawing, matchesBreakpoint, board } = this.props;
    if (this.checkLoading()) {
      return <LoadingIndicator expand />;
    }

    if (this.checkErrors()) {
      return (
        <div className="Drawings-alert">
          <Alert variant="danger">
            <p>
              There was a problem retrieving the Drawings.
              <br />
              Please try again later.
            </p>
          </Alert>
        </div>
      );
    }

    if (!this.hasSubscribed) {
      this.subscribe();
    }

    const isDesktopOrLarger = matchesBreakpoint;

    return (
      <div className="drawings-page-wrapper">
        <div className="drawings-page-container">
          <div className="drawing-window">
            <div className="page-left-panel">
              <div className="drawing-content-wrapper">
                <div className="drawing-content">
                  {this.renderDrum()}
                  {this.renderTickets()}
                </div>
              </div>
              <Link to={'/drawings'} className="exit-button drawings-exit">
                <img src={CloseIcon} alt="Close Active Drawing" />
              </Link>
            </div>
            {isDesktopOrLarger && (
              <div className="page-right-panel">
                {this.renderLeaderboard()}
                <GameChat
                  room={`drw_${drawing.id}`}
                  title="Drawing Chat"
                  participantData={board}
                />
              </div>
            )}
            <ADialog
              show={this.state.show === 'confirmation'}
              onClose={() => this.handleClose()}
              className="a-dialog-drawings-confirm add-tickets"
              closeIcon={true}
              hideFooter={!this.state.title}
              hideHeader={!this.state.title}
              title={this.state.title}
              message={this.state.message}
              closeBtnCaption="Cancel"
              closeBtnClassName="button-color-blue"
              buttons={[
                {
                  caption: 'Confirm',
                  onClick: () => this.handleAddTicketsToUser(),
                  variant: 'success'
                }
              ]}
            />

            <ADialog
              show={this.state.show === 'eligibility'}
              title="Eligibility"
              onClose={() => this.handleClose()}
              className="a-dialog-drawings-confirm eligibility"
              hideFooter={true}
              closeIcon={true}
            >
              <div className="eligibility">
                <SafeMarkdown>{this.props.eligibilityText}</SafeMarkdown>
              </div>
            </ADialog>
          </div>
        </div>
      </div>
    );
  }
}

ViewDrawing.propTypes = {
  drawing: PropTypes.object.isRequired
};

const QUERY_DRAWING_EVENTS = gql`
  query drawingsEvents {
    drawingsEvents {
      drawingsEvents {
        drawingId
        desc
        date
        name
        event
        user {
          userId
          displayName
          avatarData
        }
        rank
        tickets
        prizes {
          prizes {
            name
            url
            category
          }
        }
      }
    }
  }
`;

const SUBSCRIPTION_DRAWING_EVENTS = gql`
  subscription AllDrawingsUpdates {
    allDrawingsUpdates {
      drawingId
      name
      event
      desc
      date
      user {
        userId
        displayName
      }
      rank
      tickets
      prizes {
        prizes {
          name
          url
          category
        }
      }
    }
  }
`;

const QUERY_GET_DRAWING = gql`
  query GetDrawing($input: GetDrawing!) {
    drawing(input: $input) {
      id
      name
      enabled
      url
      description
      drawTime
      hasEnteredFreeTicket
      allTicketsAllowed
      groupId
      drawingState
      serverTime
      userInGroup
      winningPlaces {
        winningPlaces {
          place
          prize {
            id
            name
            url
            category
          }
        }
      }
      drawingWinners {
        drawingWinners {
          rank
          claimed
          user {
            userId
            displayName
          }
        }
      }
    }
  }
`;

const QUERY_GET_AVAIL_TICKETS = gql`
  query {
    patronAssets {
      tickets
    }
  }
`;

const QUERY_GET_BOARD = gql`
  query DrawingBoard($input: GetDrawingBoard!) {
    drawingBoard(input: $input) {
      totalPlayers
      totalEnteredTickets
      myEnteredTickets
      drawingBoard {
        user {
          userId
          displayName
          avatarData
        }
        ticketsCount
      }
    }
  }
`;

const SUBSCRIPTION_BOARD_UPDATES = gql`
  subscription DrawingUpdates($input: DrawingUpdatesInput!) {
    drawingUpdates(input: $input) {
      event
      user {
        userId
      }
      drawingBoard {
        totalPlayers
        totalEnteredTickets
        myEnteredTickets
        drawingBoard {
          user {
            userId
            displayName
            avatarData
          }
          ticketsCount
        }
      }
    }
  }
`;

const MUTATION_ADD_TICKET_TO_DRAWING = gql`
  mutation addMyTicketsToDrawing($input: AddMyTicketsToDrawingInput!) {
    addMyTicketsToDrawing(input: $input) {
      success
      message
      affectedCount
    }
  }
`;

const QUERY_ELIGIBILITY = gql`
  query eligibility {
    eligibility {
      text
    }
  }
`;

const MUTATION_ADD_FREE_TICKET_TO_DRAWING = gql`
  mutation addFreeTicket($input: AddFreeTicketInput!) {
    addFreeTicket(input: $input) {
      success
    }
  }
`;

const withData = compose(
  withApollo,
  getUserData({
    name: 'userData',
    props: ({ userData }) => {
      return {
        userData,
        subscribeToLocationData: () => {
          return userData.subscribeToMore({
            document: SUBSCRIPTION_PREFERRED_LOCATION_CHANGED,
            updateQuery: (prev, { subscriptionData }) => {
              if (
                subscriptionData?.data?.newPreferredLocation &&
                subscriptionData.data.newPreferredLocation !==
                  prev.user.preferredLocation
              ) {
                return {
                  ...prev,
                  user: {
                    ...prev.user,
                    preferredLocation:
                      subscriptionData.data.newPreferredLocation
                  }
                };
              }
              return prev;
            }
          });
        }
      };
    }
  }),
  graphql(getDrawingsQuery(), {
    options: props => ({
      fetchPolicy: 'network-only',
      variables: {
        input: {
          states: ['InProgress', 'Upcoming'],
          onlyMy: false,
          enabled: true
        }
      }
    }),
    props: ({ data, ownProps }) => {
      let drawings = (data.drawings && data.drawings.drawings) || [];

      drawings.forEach(augmentDrawing);

      return {
        commonDrawingsData: data,
        commonDrawings: drawings.sort(
          (lhs, rhs) => lhs.drawTime.getTime() - rhs.drawTime.getTime()
        )
      };
    }
  }),

  graphql(QUERY_DRAWING_EVENTS, {
    options: props => {
      return {
        variables: { input: {} },
        fetchPolicy: 'cache-and-network'
      };
    },
    props: ({ data, ownProps }) => {
      const drawingsEvents =
        (!data.loading &&
          !data.error &&
          data.drawingsEvents &&
          data.drawingsEvents.drawingsEvents) ||
        [];

      ownProps.addDrawingEvents(drawingsEvents);

      return {
        drawingsEventsData: data,
        subscribeToScrollUpdates: (props, updateByEvents) => {
          const { client } = props;
          let user = props.userData.user;

          if (!user) {
            props.userData.refetch().then(resp => {
              user = resp.data.user;
            });
          }

          return data.subscribeToMore({
            document: SUBSCRIPTION_DRAWING_EVENTS,
            updateQuery: async (prev, { subscriptionData }) => {
              let resp = cloneDeep(prev);
              ownProps.addDrawingEvent(subscriptionData.data);

              const updatedDrawing = await updateDrawings(
                client,
                user.userId,
                subscriptionData.data
              );

              if (
                subscriptionData &&
                subscriptionData.data &&
                subscriptionData.data.drawingId === ownProps.match.params.id
              ) {
                // -> pass in updatedEvent if the IDs match (drawing and from commonDrawing)
                updateByEvents(updatedDrawing);
              }
              return resp;
            },
            onError: e => {
              console.error('SUBSCRIPTION_DRAWING_EVENTS error', e);
            }
          });
        }
      };
    }
  }),
  //! -> QUERY_DRAWING_EVENTS + cacheHandling functions need commonDrawings and myDrawings queries
  //! -> working on solution
  graphql(getDrawingsQuery(), {
    options: props => ({
      fetchPolicy: 'network-only',
      variables: {
        input: {
          states: ['InProgress', 'Upcoming'],
          onlyMy: false,
          enabled: true
        }
      }
    }),
    props: ({ data, ownProps }) => {
      let drawings = (data.drawings && data.drawings.drawings) || [];

      drawings.forEach(augmentDrawing);

      return {
        commonDrawingsData: data,
        commonDrawings: drawings.sort(
          (lhs, rhs) => lhs.drawTime.getTime() - rhs.drawTime.getTime()
        )
      };
    }
  }),
  //  myDrawings
  graphql(getDrawingsQuery(), {
    options: props => ({
      fetchPolicy: 'network-only',
      variables: {
        input: {
          states: ['InProgress', 'Upcoming'],
          onlyMy: true,
          enabled: true
        }
      }
    }),
    props: ({ data, ownProps }) => {
      let drawings = (data.drawings && data.drawings.drawings) || [];
      drawings.forEach(augmentDrawing);

      return {
        myDrawingsData: data,
        myDrawings: drawings.sort(
          (lhs, rhs) => lhs.drawTime.getTime() - rhs.drawTime.getTime()
        )
      };
    }
  }),

  graphql(QUERY_GET_DRAWING, {
    options: props => {
      const { match } = props;
      const { id } = match.params;
      return {
        variables: {
          input: {
            id: id
          }
        },
        fetchPolicy: 'network-only'
      };
    },
    props: ({ data }) => {
      let drawing = data.drawing || {};
      let augDrawing = augmentDrawing(drawing);
      return {
        drawingData: data,
        drawing: augDrawing
      };
    }
  }),
  graphql(QUERY_ELIGIBILITY, {
    options: props => ({
      fetchPolicy: 'cache-and-network'
    }),
    props: ({ data }) => {
      let eligibilityText = (data.eligibility && data.eligibility.text) || '';
      return { eligibilityText };
    }
  }),
  graphql(QUERY_GET_AVAIL_TICKETS, {
    options: props => ({
      fetchPolicy: 'cache-and-network'
    }),
    props: ({ data }) => ({
      ticketsNumData: data,
      myTicketsNum: (data.patronAssets && data.patronAssets.tickets) || 0
    })
  }),
  graphql(QUERY_GET_BOARD, {
    options: props => {
      const { match } = props;
      const { id } = match.params;
      return {
        variables: {
          input: {
            id: id
          }
        },
        fetchPolicy: 'network-only'
      };
    },
    props: ({ data, ownProps }) => {
      const subData = data.drawingBoard || {};
      const board = [...(subData.drawingBoard || [])];

      const ticketsData = {
        total: subData.totalEnteredTickets || 0,
        my: subData.myEnteredTickets || 0,
        players: subData.totalPlayers || 0
      };

      return {
        boardData: data,
        ticketsData,
        board,
        subscribeToBoardUpdates: (
          drawingId,
          onSubscribeToEventsUpdate,
          updateMyTickets
        ) => {
          return data.subscribeToMore({
            document: SUBSCRIPTION_BOARD_UPDATES,
            variables: { input: { drawingId: ownProps.match.params.id } },
            updateQuery: (prev, { subscriptionData }) => {
              const resp = subscriptionData.data;

              if (
                !resp ||
                !SUBSCRIPTION_BOARD_UPDATES_EVENTS.includes(resp.event)
              ) {
                return null;
              }
              // console.log(
              //   'SUBSCRIPTION_BOARD_UPDATES data',
              //   resp, 'entered', resp.drawingBoard.myEnteredTickets
              // );
              // console.log(
              //   'SUBSCRIPTION_BOARD_UPDATES prev',
              //   prev
              // );
              // console.log(
              //   'SUBSCRIPTION_BOARD_UPDATES props',
              //   ownProps
              // );

              if (
                resp.user &&
                resp.user.userId === ownProps.userData.user.userId
              ) {
                if (onSubscribeToEventsUpdate) {
                  onSubscribeToEventsUpdate(
                    resp.drawingBoard.myEnteredTickets,
                    resp.event
                  );
                }

                if (resp.event === DRAWING_BOARD_EVENTS.CLAIMED) {
                  //  player claimed the prize --> manually zero-out tickets
                  resp.drawingBoard.myEnteredTickets = 0;
                  updateMyTickets(0);
                } else if (resp.event === DRAWING_BOARD_EVENTS.REFUNDED) {
                  //  tickets refunded -->  manually zero-out tickets
                  resp.drawingBoard.myEnteredTickets = 0;
                  updateMyTickets(0);
                } else if (
                  !SUBSCRIPTION_BOARD_UPDATES_EVENTS.includes(resp.event)
                ) {
                  //  wrong user, invalidate
                  resp.drawingBoard.myEnteredTickets = null;
                  updateMyTickets(null);
                }
              }

              return resp;
            },

            onError: e => {
              console.error('subscribeToBoardUpdates error', e);
            }
          });
        }
      };
    },
    skip: props => !props.userData || !props.userData.user
  }),
  graphql(MUTATION_ADD_TICKET_TO_DRAWING, {
    props: ({ ownProps, mutate }) => ({
      addMyTicketsToDrawing: amount =>
        mutate({
          variables: {
            input: {
              amount,
              drawingId: ownProps.match.params.id
            }
          }
        })
    })
  }),
  graphql(MUTATION_ADD_FREE_TICKET_TO_DRAWING, {
    props: ({ ownProps, mutate }) => ({
      addFreeTicketToDrawing: () =>
        mutate({
          variables: {
            input: {
              drawingId: ownProps.match.params.id
            }
          }
        })
    })
  }),
  withMediaQuery(LG_BREAKPOINT_AND_UP)
);

const mapDispatchToProps = dispatch => {
  return {
    addDrawingEvents: events => {
      dispatch(addDrawingEvents(events));
    },
    addDrawingEvent: event => {
      dispatch(addDrawingEvent(event));
    },
    updateLastDrawingEvent: event => {
      dispatch(updateLastDrawingEvent(event));
    }
  };
};

export default connect(
  null,
  mapDispatchToProps
)(withData(withRouter(ViewDrawing)));

//  event:
//    "created"
//    "updated"
//    "deleted"
//    "refunded"
//    "addTickets"
//    "addFreeTicket"
//    "notifyStart"
//    "start"
//    "round"
//    "winner"
//    "claimed"
//    "end"
